module.exports = __webpack_public_path__ + "static/media/ic_explore.38905a07.svg";